export default __webpack_public_path__ + "static/media/win.8d226190.png";